import { ListBuilder } from "@redriver/cinnamon";
import { TablePagination } from "components/pagination";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { getDocumentAuditTrail } from "./actions";
import DocumentAuditTrailTable from "./DocumentAuditTrailTable";
import HeaderBar from "./HeaderBar";

const DocumentAuditTrail = ({}) => {
  const dispatch = useDispatch();

  const [tablesToShow, setTablesToShow] = useState([]);

  return (
    <ListBuilder
      initialPagination={{ pageSize: 100, pageNumber: 1 }}
      loadAction={getDocumentAuditTrail}
      initialFilters={{
        search: "",
      }}
      dataTransform={(data) => data.results}
      totalTransform={(data) => data.totalResults}
      renderList={(data, state, events) => (
        <React.Fragment>
          <HeaderBar
            state={state}
            events={events}
            initialPageSize={100}
            onAdded={events.onRefresh}
            pageNumber={state.pagination.pageNumber}
            pageSize={state.pagination.pageSize}
          />
          <DocumentAuditTrailTable
            data={data}
            state={state}
            events={events}
            tablesToShow={tablesToShow}
            setTablesToShow={setTablesToShow}
          />
          <TablePagination
            pageNumber={state.pagination.pageNumber}
            onChange={events.onChangePagination}
            pageSize={state.pagination.pageSize}
            totalItems={state.total}
          />
        </React.Fragment>
      )}
    />
  );
};

export default DocumentAuditTrail;
